import { render, staticRenderFns } from "./ItalicButton.vue?vue&type=template&id=0aeee656&"
import script from "./ItalicButton.vue?vue&type=script&lang=js&"
export * from "./ItalicButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports